<template>
  <div>
    <div class="e-filter-container">
      <a v-b-toggle.sidebar-right.sidebar-backdrop class="e-filter-btn"><i class="lnr lnr-funnel"></i></a>
    </div>
    <filters-component v-on:fromFilter="filter" :filterType="filterType"></filters-component>
    <h4
      class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4"
    >
      <div class="e-mtavr-15">გადამოწმებული კლიენტების ბაზა</div>
     <!-- <button @click="addRow">aa</button> -->
       <!-- <a href="https://www.treasury.gov/ofac/downloads/sanctions/1.0/sdn_advanced.xml" download>Download Now</a> -->
    </h4>

    <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 col-xl-12">
        <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
          <div class="e-loader-back" v-if="disableTable">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">მუშავდება...</div>
            </div>
          </div>
          <vue-good-table
          ref="clientsTable"
          mode="remote"
          :pagination-options="pgnOptions"
          :columns="clientTableColumns"
          :rows="clientTableRows"
          :search-options="{enabled: true, placeholder: 'სახელი ან გვარი (მოსაძებნად დააჭირეთ Enter-ს)', trigger: 'enter'}"
          :totalRows="totalRecords"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-row-click="clientTableRowClick"
          @on-search="onSearch"
          >
          <div slot="table-actions">
          <button class="btn btn-link e-mtavr-17 btn-outline-secondary" v-b-modal.excelImportModal @click="SelectFile">
                <i class="lnr lnr-download mr-2"></i> ექსელიდან იმპორტი
          </button>
          <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="exportToExcel()">
                <i class="lnr lnr-upload mr-2"></i> ექსელში ექსპორტი
          </button>
        </div>
         <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'ScrStatus'">
                <div
                  v-if="props.row.matchCount > 0 || props.row.dboforigination ==='BlackList'"
                  class="badge badge-danger e-nusx-8"
                >საყურადღებო</div>
                <div v-else class="badge badge-success e-nusx-8">არცერთი დამთხვევა</div>
              </div>
              <div v-else-if="props.column.field == 'Deci'">
                <div v-if="props.row.dboforigination ==='BlackList'"
                  class="badge badge-outline-danger ml-1 mr-1 mb-1 pt-1 float-left e-ts-07rem"
                > Black List </div>
                <div v-for="d in props.row.decisionsArry" :key="d.$index"
                  class="badge badge-outline-danger ml-1 mr-1 mb-1 float-left e-ts-07rem"
                >{{ d }}</div>
              </div>
              <div v-else-if="props.column.field == 'RelatedPerson'">
                <div v-for="relper in props.row.clientRelations" :key="relper.$index">
                  <span class="e-whitespace-nowrap"><small class="text-muted e-nusx-8">დაკავშირებული პირის დასახელება: </small><strong class="e-whitespace-nowrap">{{relper.clientName}}</strong></span> <br />
                  <span class="e-whitespace-nowrap"><small class="text-muted e-nusx-8">დაკავშირებული პირის იდენტიფიკატორი: </small><strong class="e-whitespace-nowrap">{{relper.clientNo}}</strong></span> <br />
                  <span class="e-whitespace-nowrap"><small class="text-muted e-nusx-8">კავშირის ტიპი: </small><strong class="e-whitespace-nowrap e-nusx-8">{{relper.relationTypeName}}</strong></span> <br />
                </div>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
          </vue-good-table>
      </div>
    </div>
    <section>
      <input type="file" @change="onChange" id="ExcelImportFile" ref="ExcelImportFile" class="e-hidden"/>
      <xlsx-read :file="file">
        <xlsx-json :sheet="selectedSheet">
          <template #default="{ collection }">
            <div>
              {{ collection ? confirmLoad(collection) : null}}
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </section>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import XlsxRead from 'vue-xlsx/dist/components/XlsxRead'
import XlsxJson from 'vue-xlsx/dist/components/XlsxJson'
import FiltersComponent from '../components/filters.vue'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  components: {
    XlsxRead,
    XlsxJson,
    FiltersComponent
  },
  metaInfo: {
    title: ' - კლიენტთა ბაზის სქრინინგი'
  },
  data () {
    return {
      totalRecords: 0,
      totalUprocessed: 0,
      disableTable: false,
      filterType: 'clients',
      pgnOptions: {
        enabled: true,
        mode: 'records',
        perPage: 5,
        position: 'top',
        perPageDropdown: [10, 15, 25, 50],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: 'შემდეგი',
        prevLabel: 'წინა',
        rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
        ofLabel: '-ჩანაწერი სულ',
        pageLabel: 'გვერდი', // for 'pages' mode
        allLabel: 'ყველა'
      },
      fileCheckError: false,
      clientScreeningrequestId: 0,
      HeaderParams: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      // currentUser: this.$store.getters.GetCurrentUser,
      clientsListItem: [
      ],
      clientRelationshipItem: [],
      loading: false,
      selectedSheet: 'ClientsTable',
      excelfiledata: [],
      file: null,
      dataForTable: [{}],
      clientTableColumns: [
        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'ScrStatus'
        },
        {
          label: 'მოთხოვნის სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'requestStatusText'
        },
        {
          label: 'დამუშავების შედეგი',
          field: 'Deci',
          thClass: 'e-mtavr-17 e-ts-08rem e-whitespace-nowrap',
          tdClass: 'text-center',
          type: 'text'
        },
        {
          label: 'სამართლებრივი სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'juridicalStatusDesc'
        },
        {
          label: 'დასახელება',
          html: true,
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-whitespace-nowrap',
          field: 'FullName'
        },
        {
          label: 'ძებნის დამატებითი პარამეტრი',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-whitespace-nowrap',
          html: true,
          field: 'searchParams'
        },
        {
          label: 'იდენტიფიკატორი',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-whitespace-nowrap',
          html: true,
          field: 'Identificator'
        },
        {
          label: 'დაკავშირებული პირი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'RelatedPerson'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'recDate'
        },
        {
          label: 'მომხმარებელი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'UserFullName'
        }
      ],
      clientTableRows: [],
      test: {
        id: 20,
        info: 'ssaaqq'
      },
      serverParams: {
        columnFilters: {},
        sort: [{
          field: 'id',
          type: 'desc'
        }],
        page: 1,
        perPage: 5
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    }
  },
  created () {
    this.clientScreeningrequestId = 0
    this.loadItems()
    setInterval(this.checkTotalUprocessed, 18000000)
  },
  methods: {
    checkTotalUprocessed () {
      this.loadItems()
      // Update the disableTable parameter based on the value
      this.disableTable = this.totalUprocessed > 0
    },
    AddAMLClients (data) {

    },
    exportToExcel () {
      this.loading = true
      // var ExcelServerParam = {
      //   columnFilters: {},
      //   sort: [{
      //     field: 'id',
      //     type: 'desc'
      //   }],
      //   page: 1,
      //   perPage: this.totalRecords
      // }
      const filterPars = this.serverParams
      filterPars.perPage = this.totalRecords

      // filterPars.perPage = 10000
      // filterPars.page = 3
      // console.log(filterPars)
      BaseService.GetClientsServerSide(this.HeaderParams, filterPars)
        .then(res => {
          console.log(res)
          if (res.data.success) {
            this.loading = false
            res.data.result.amlClients.map(r => {
              r.FullName = r.firstName + ' ' + r.lastName
              r.Identificator = r.juridicalStatusId === 1 ? 'პირადი ნომერი: ' +
              (r.personalN === null ? '' : r.personalN) + 'პირადობის მოწმობის ნომერი: ' +
              (r.documentN === null ? '' : r.documentN) + 'დაბადების თარიღი: ' +
              (r.brthDate === null ? '' : moment(r.brthDate).format('DD.MM.YYYY')) + 'მისამართის ქვეყანა: ' +
              (r.addressCountry === null ? '' : r.addressCountry) + 'მისამართის ქალაქი: ' +
              (r.city === null ? '' : r.city) + 'მისამართი: ' +
              (r.address === null ? '' : r.address) + 'საფოსტო ინდექსი: ' +
              r.postalCode + '' : 'საიდენტიფიკაციო ნომერი: ' +
              r.identityN + 'მისამართის ქვეყანა: ' +
              (r.addressCountry === null ? '' : r.addressCountry) + 'მისამართის ქალაქი: ' +
              (r.city === null ? '' : r.city) + 'მისამართი: ' +
              (r.address === null ? '' : r.address) + 'საფოსტო ინდექსი: ' +
              r.postalCode + ''
              r.UserFullName = r.userFirstName + ' ' + r.userLastName
              r.recDate = r.recDate === null ? '' : moment(r.recDate).format('DD.MM.YYYY HH:mm:SS')
            })
            // eslint-disable-next-line no-debugger
            debugger
            const sheetData = []
            var data = res.data.result.amlClients
            data.map(res => {
              console.log(res)
              sheetData.push({
                'სქრინინგ სტატუსი': res.matchCount > 0 ? 'საყურადღებო' : 'არცერთი დამთხვევა',
                'მოთხოვნის სტატუსი': res.requestStatusText,
                'დამუშავების სტატუსი': res.decisions,
                'სამართლებრივი სტატუსი': res.juridicalStatusDesc,
                'საძიებო ტექსტი': res.FullName,
                იდენტიფიკატორი: res.Identificator,
                'მოთხოვნის დრო': res.recDate,
                მომხმარებელი: res.userFirstName + ' ' + res.userLastName
              })
            })
            var newWB = XLSX.utils.book_new()
            var newWS = XLSX.utils.json_to_sheet(sheetData)
            XLSX.utils.book_append_sheet(newWB, newWS, 'Data')
            XLSX.writeFile(newWB, 'ClientsScreeningExport-' + moment(Date.now()).format('DD.MM.YYYY') + '.xlsx')
            this.loading = false
          } else {
            console.log('Error: ' + res)
          }
          // if (res.data.success) {
          //   for (var i = 0, len = res.data.result.requests.length; i < len; i++) {
          //     res.data.result.requests[i].brthDate === null ? res.data.result.requests[i].brthDate = null : res.data.result.requests[i].brthDate = moment(res.data.result.requests[i].brthDate).format('DD.MM.YYYY')
          //     res.data.result.requests[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + res.data.result.requests[i].brthDate + '</strong>'
          //     res.data.result.requests[i].FullAddress = 'ქვეყანა: <strong>' + res.data.result.requests[i].country + '</strong></br> მისამართი: <strong>' + res.data.result.requests[i].address + '</strong>'
          //     res.data.result.requests[i].LastCommentItem = 'კომენტარი: <strong>' + res.data.result.requests[i].commentText + '</strong></br> ავტორი: <strong>' + (res.data.result.requests[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : res.data.result.requests[i].commentUserName) + '</strong>'
          //     res.data.result.requests[i].LastActionUser = res.data.result.requests[i].userFirstName + ' ' + res.data.result.requests[i].userLastName
          //   }
          //   this.RequestsTablerows = res.data.result.requests
          //   this.totalRecords = res.data.result.totalNumber
          // }
        })
    },
    GetScreenedClientsList () {
      this.loading = true
      BaseService.GetAmlClientsWithRelatedPersons(this.HeaderParams)
        .then(res => {
          if (res.data.success) {
            this.loading = false
            res.data.result.map(r => {
              r.FullName = r.firstName + ' ' + r.lastName
              r.Identificator = r.juridicalStatusId === 1 ? '<small class="text-muted e-nusx-8">პირადი ნომერი: </small><strong>' +
              (r.personalN === null ? '' : r.personalN) + '</strong> </br> <small class="text-muted e-nusx-8">პირადობის მოწმობის ნომერი: </small><strong> ' +
              (r.documentN === null ? '' : r.documentN) + '</strong> </br> <small class="text-muted e-nusx-8">დაბადების თარიღი: </small><strong>' +
              (r.brthDate === null ? '' : moment(r.brthDate).format('DD.MM.YYYY')) + '</strong> </br><small class="text-muted e-nusx-8">მისამართის ქვეყანა: </small><strong>' +
              (r.addressCountry === null ? '' : r.addressCountry) + '</strong> </br> <small class="text-muted e-nusx-8">მისამართის ქალაქი: </small><strong>' +
              (r.city === null ? '' : r.city) + '</strong> </br> <small class="text-muted e-nusx-8">მისამართი: </small><strong>' +
              (r.address === null ? '' : r.address) + '</strong> </br> <small class="text-muted e-nusx-8">საფოსტო ინდექსი: </small><strong>' +
              r.postalCode + '</strong>' : '<small class="text-muted e-nusx-8">საიდენტიფიკაციო ნომერი: </small><strong>' +
              r.identityN + '</strong> </br><small class="text-muted e-nusx-8">მისამართის ქვეყანა: </small><strong>' +
              (r.addressCountry === null ? '' : r.addressCountry) + '</strong> </br> <small class="text-muted e-nusx-8">მისამართის ქალაქი: </small><strong>' +
              (r.city === null ? '' : r.city) + '</strong> </br> <small class="text-muted e-nusx-8">მისამართი: </small><strong>' +
              (r.address === null ? '' : r.address) + '</strong> </br> <small class="text-muted e-nusx-8">საფოსტო ინდექსი: </small><strong>' +
              r.postalCode + '</strong>'
              r.UserFullName = r.userFirstName + ' ' + r.userLastName
            })
            this.clientTableRows = res.data.result
          } else {
            console.log('Error: ' + res)
          }
        })
    },
    rowStyleClassFn () {
    },
    clientTableRowClick (params) {
      console.log(params)
      if (params.row.matchCount > 0) {
        const routeData = this.$router.resolve({
          name: 'ClientScreeningDetails',
          query: { clientRequestId: params.row.requestId, requestUniqueId: params.row.requestUniqueId, rowIdentRecCountry: params.row.registrationCountry, rowIdentNumber: params.row.identityN, rowAddress: params.row.address, rowRegNumber: params.row.registrationN, rowPersonalN: params.row.personalN, rowBirthDate: params.row.brthDate }
        })
        // console.log(routeData.href)
        window.open(routeData.href, '_blank')
      }

      // if (params.row.matchCount > 0) {
      //   this.clientScreeningrequestId = params.row.requestId
      //   this.$router.push(
      //     {
      //       path: 'ClientDBScreening/ClientScreeningDetails',
      //       query: { clientRequestId: params.row.requestId, requestUniqueId: params.row.requestUniqueId, rowIdentRecCountry: params.row.registrationCountry, rowIdentNumber: params.row.identityN, rowAddress: params.row.address, rowRegNumber: params.row.registrationN, rowPersonalN: params.row.personalN, rowBirthDate: params.row.brthDate }
      //     }
      //   )
      // }
    },
    SelectFile () {
      this.$refs.ExcelImportFile.click()
    },
    addRow () {
      this.excelfiledata.map(res => {
        // debugger
        this.clientsListItem.push({
          id: 0,
          juridicalStatusId: parseInt(res['გადასამოწმებელი პირის იურიდიული სტატუსი']),
          juridicalStatusDesc: res['გადასამოწმებელი პირის იურიდიული სტატუსი'] === 1 ? 'ფიზიკური პირი' : 'იურიდიული პირი',
          firstName: res['დასახელება'], //* **
          lastName: res['გადასამოწმებლი პირის გვარი'], //*
          personalN: res['პირადი ნომერი'] ? res['პირადი ნომერი'] : '', //*
          // documentN: res['პირადობის მოწმობის ნომერი'], //*
          brthDate: res['დაბადების თარიღი'] === '' || !res['დაბადების თარიღი'] ? null : moment(res['დაბადების თარიღი'], 'DD.MM.YYYY', true).format(), //*
          identityN: '' + (res['იურიდიული პირის საიდენტიფიკაციო ნომერი'] ? res['იურიდიული პირის საიდენტიფიკაციო ნომერი'] : ''), //* *
          registrationN: '' + (res['იურიდიული პირის სარეგისტრაციო ნომერი'] ? res['იურიდიული პირის სარეგისტრაციო ნომერი'] : ''), //* *
          // addressCountryId: 84,
          addressCountryISO: res['მისამართის ქვეყანა'],
          city: res['მისამართის ქალაქი'],
          address: res['მისამართი'],
          registrationCountryISO: res['რეგისტრაციის ქვეყანა'],
          registrationCountry: res['რეგისტრაციის ქვეყანა'],
          // postalCode: '' + (res['საფოსტო ინდექსი'] ? res['საფოსტო ინდექსი'] : ''),
          // citizenship: res['მოქალაქეობა'],
          recDate: moment(Date.now()).format(),
          deleteStatus: false,
          organisationId: this.currentUser.organizationID,
          organisationUserId: this.currentUser.id
          // externalclientId: parseInt(res['კლიენტის უნიკალური კოდი ID'])
        })
        // this.clientsListItem.push({
        //   id: 0,
        //   clientNumber: res['კლიენტის უნიკალური კოდი ID'],
        //   juridicalStatusId: parseInt(res['გადასამოწმებელი პირის იურიდიული სტატუსი']),
        //   juridicalStatusDesc: res['გადასამოწმებელი პირის იურიდიული სტატუსი'] === 1 ? 'ფიზიკური პირი' : 'იურიდიული პირი',
        //   firstName: res['გადასამოწმებლი პირის დასახელება'], //* **
        //   lastName: res['გადასამოწმებლი პირის გვარი'], //*
        //   personalN: res['პირადი ნომერი'] ? res['პირადი ნომერი'] : '', //*
        //   documentN: res['პირადობის მოწმობის ნომერი'], //*
        //   brthDate: res['დაბადების თარიღი'] === '' || !res['დაბადების თარიღი'] ? null : moment(res['დაბადების თარიღი']).format(), //*
        //   identityN: '' + (res['საიდენტიფიკაციო ნომერი'] ? res['საიდენტიფიკაციო ნომერი'] : ''), //* *
        //   registrationN: '' + (res['სარეგისტრაციო ნომერი'] ? res['სარეგისტრაციო ნომერი'] : ''), //* *
        //   addressCountryId: 84,
        //   addressCountry: res['ქვეყანა'],
        //   city: res['ქალაქი'],
        //   address: res['მისამართი'],
        //   registrationCountryId: 84,
        //   registrationCountry: res['რეზიდენტობა'],
        //   postalCode: '' + (res['საფოსტო ინდექსი'] ? res['საფოსტო ინდექსი'] : ''),
        //   citizenship: res['მოქალაქეობა'],
        //   recDate: moment(Date.now()).format(),
        //   deleteStatus: false,
        //   organisationId: this.currentUser.organizationID,
        //   organisationUserId: 0,
        //   externalclientId: parseInt(res['კლიენტის უნიკალური კოდი ID'])
        // })
        // if (parseInt(res['დაკავშირებული პირის უნიკალური ნომერი/ID']) > 0) {
        //   this.clientRelationshipItem.push({
        //     id: 0,
        //     clientId1: 0,
        //     clientId2: 0,
        //     externalClientId2: parseInt(res['დაკავშირებული პირის უნიკალური ნომერი/ID']),
        //     externalClientId1: parseInt(res['კლიენტის უნიკალური კოდი ID']),
        //     relationType: parseInt(res['კავშირის ტიპი'])
        //   })
        // }
        // this.clientTableRows.push({
        //   id: res['#'],
        //   juridicalStatusId: res['გადასამოწმებელი პირის იურიდიული სტატუსი'],
        //   Name: res['გადასამოწმებლი პირის დასახელება'],
        //   Identificator: res['იდენტიფიკატორი'],
        //   RelatedPersonName: res['დაკავშირებული პირის დასახელება'],
        //   RelatedPersonIdentificator: res['დაკავშირებული პირის იდენტიფიკატორი']
        // })
      })
      console.log(this.clientsListItem)

      this.clientsListItem.forEach(element => {
        // eslint-disable-next-line no-debugger
        debugger
        if (element.juridicalStatusId === 0 || element.juridicalStatusId > 2) {
          this.fileCheckError = true
        }
        if (element.firstName === '' || (element.juridicalStatusId === 1 && element.lastName === '')) {
          this.fileCheckError = true
        }
      })
      if (this.fileCheckError) {
        this.$swal({
          title: 'ყურადღება!',
          html: '<span class="e-nusx-8 e-ts-09rem">არ გაქვთ შევსებული აუცილებელი ველები ან მითითებული გაქვთ არასწორი მონაცემი აუცილებელ ველებში. ექსელის ფაილის შეტვირთვა ვერ შესრულდება!</span>',
          showCancelButton: false,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'თანხმობა',
          heightAuto: false,
          customClass: 'e-nusx-8',
          confirmButtonClass: 'e-mtavr-17',
          keydownListenerCapture: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.fileCheckError = false
            this.excelfiledata = []
            return false
          }
        })
        this.fileCheckError = false
        this.excelfiledata = []
        return false
      }
      BaseService.AddAmlClients(this.HeaderParams, this.clientsListItem)
        .then(res => {
          if (res.data.success) {
            BaseService.AddAmlClientsRelations(this.HeaderParams, this.clientRelationshipItem)
              .then(r => {
                this.loadItems()
                this.$refs.ExcelImportFile.value = null
                this.clientsListItem = []
                this.fileCheckError = false
                this.excelfiledata = []
              })
          }
        })
    },
    confirmLoad (data) {
      this.excelfiledata = data
      this.$swal({
        title: 'ყურადღება!',
        html: '<span class="e-nusx-8 e-ts-09rem">არჩეულ ფაილში ნაპოვნია</span> <strong class="e-eng-font">' + data.length + ' ჩანაწერი.</strong>  </br> <span class="e-nusx-8 e-ts-09rem">თანახმა ხართ ჩაიტვირთოს ჩანაწერები კლიენტების ცხრილში?</span>',
        showCancelButton: false,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'თანხმობა',
        heightAuto: false,
        customClass: 'e-nusx-8',
        confirmButtonClass: 'e-mtavr-17',
        keydownListenerCapture: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.addRow()
        }
      })
    },
    onChange (event) {
      this.file = event.target.files ? event.target.files[0] : null
    },
    updateParams (newProps) {
      console.log(newProps)
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange (params) {
      let sort = []
      sort = params
      this.updateParams({
        sort
        // sort: [
        //   {
        //     type: params.sortType,
        //     // field: this.RequestsTablecolumns[params.columnIndex].field
        //     field: params
        //   }
        // ]
      })
      this.loadItems()
    },
    filter (value) {
      console.log(value)
      if (value) {
        this.onColumnFilter(value)
      }
    },
    onColumnFilter (params) {
      if (params.columnFilters.matchPercent === '') {
        params.columnFilters.matchPercent = 0
      }
      if (params.columnFilters.matchCount) {
        params.columnFilters.matchCount = params.columnFilters.ScrStatus
        delete params.columnFilters.ScrStatus // no warning
      }
      if (params.columnFilters.matchPercent) {
        params.columnFilters.matchPercent = parseInt(params.columnFilters.matchPercent)
      }
      this.updateParams(params)
      this.loadItems()
    },

    // load items is what brings back the rows from server
    loadItems () {
      BaseService.GetClientsServerSide(this.HeaderParams, this.serverParams)
        .then(res => {
          console.log(res.data.result)
          if (res.data.success) {
            for (var i = 0, len = res.data.result.amlClients.length; i < len; i++) {
              // if (res.data.result.amlClients[i].decisions !== null) {
              //   console.log(res.data.result.amlClients[i])
              // }
              // res.data.result.amlClients[i].decisionsArry = null

              res.data.result.amlClients[i].decisionsArry = res.data.result.amlClients[i].decisions !== null ? res.data.result.amlClients[i].decisions.split(',').map(word => word.trim()) : null
            }
            this.loading = false
            res.data.result.amlClients.map(r => {
              r.FullName = '<strong>' + r.firstName + ' ' + r.lastName + '</strong>'
              r.searchParams = '</strong><small class="text-muted e-nusx-8">დაბადების თარიღი: </small><strong>' +
                (r.brthDate === null ? '' : moment(r.brthDate).format('DD.MM.YYYY')) +
              '</strong></br><small class="text-muted e-nusx-8">სქესი: </small><strong>' +
                (r.gender === null ? '' : r.gender) +
                  '</strong> </br> <small class="text-muted e-nusx-8">მის. ქვეყანა: </small><strong>' +
              (r.addressCountry === null ? '' : r.addressCountry) +
                  '</strong> </br> <small class="text-muted e-nusx-8">მის. ქალაქი: </small><strong>' +
              (r.city === null ? '' : r.city)
              r.Identificator = r.juridicalStatusId === 1 ? r.personalN : r.identityN

              // '<small class="text-muted e-nusx-8">პირადი ნომერი: </small><strong>' +
              // (r.personalN === null ? '' : r.personalN)
              // '</strong> </br> <small class="text-muted e-nusx-8">პირადობის მოწმობის ნომერი: </small><strong> ' +
              // (r.documentN === null ? '' : r.documentN) +

              // '</strong> </br><small class="text-muted e-nusx-8">მისამართის ქვეყანა: </small><strong>' +
              // (r.addressCountry === null ? '' : r.addressCountry) +
              // '</strong> </br> <small class="text-muted e-nusx-8">მისამართის ქალაქი: </small><strong>' +
              // (r.city === null ? '' : r.city) +

              // '</strong> </br> <small class="text-muted e-nusx-8">საფოსტო ინდექსი: </small><strong>' +
              // r.postalCode +
              //   : '<small class="text-muted e-nusx-8">საიდენტიფიკაციო ნომერი: </small><strong>' +
              // r.identityN
              // // +
              // '</strong> </br><small class="text-muted e-nusx-8">რეგისტრაციის ნომერი: </small><strong>' +
              // (r.registrationN === null ? '' : r.registrationN) +
              // '</strong> </br><small class="text-muted e-nusx-8">რეგისტრაციის ქვეყანა: </small><strong>' +
              // (r.registrationCountry === null ? '' : r.registrationCountry) +
              // // '</strong> </br> <small class="text-muted e-nusx-8">მისამართის ქალაქი: </small><strong>' +
              // // (r.city === null ? '' : r.city) +
              // '</strong> </br> <small class="text-muted e-nusx-8">მისამართი: </small><strong>' +
              // (r.address === null ? '' : r.address)
              // '</strong> </br> <small class="text-muted e-nusx-8">საფოსტო ინდექსი: </small><strong>' +
              // r.postalCode + '</strong>'
              r.UserFullName = r.userFirstName + ' ' + r.userLastName
              r.recDate = r.recDate === null ? '' : moment(r.recDate).format('DD.MM.YYYY HH:mm:SS')
            })
            this.clientTableRows = res.data.result.amlClients
            this.totalRecords = res.data.result.totalNumber
            this.totalUprocessed = res.data.result.totalUprocessed
            if (res.data.result.totalUprocessed > 0) {
              this.loading = true
              this.disableTable = this.totalUprocessed > 0
              setInterval(this.checkTotalUprocessed, 180000)
            }
            if (res.data.result.totalUprocessed === 0) {
              this.loading = false
              this.disableTable = this.totalUprocessed > 0
              setInterval(this.checkTotalUprocessed, 18000000)
            }
          } else {
            console.log('Error: ' + res)
          }
          // if (res.data.success) {
          //   for (var i = 0, len = res.data.result.requests.length; i < len; i++) {
          //     res.data.result.requests[i].brthDate === null ? res.data.result.requests[i].brthDate = null : res.data.result.requests[i].brthDate = moment(res.data.result.requests[i].brthDate).format('DD.MM.YYYY')
          //     res.data.result.requests[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + res.data.result.requests[i].brthDate + '</strong>'
          //     res.data.result.requests[i].FullAddress = 'ქვეყანა: <strong>' + res.data.result.requests[i].country + '</strong></br> მისამართი: <strong>' + res.data.result.requests[i].address + '</strong>'
          //     res.data.result.requests[i].LastCommentItem = 'კომენტარი: <strong>' + res.data.result.requests[i].commentText + '</strong></br> ავტორი: <strong>' + (res.data.result.requests[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : res.data.result.requests[i].commentUserName) + '</strong>'
          //     res.data.result.requests[i].LastActionUser = res.data.result.requests[i].userFirstName + ' ' + res.data.result.requests[i].userLastName
          //   }
          //   this.RequestsTablerows = res.data.result.requests
          //   this.totalRecords = res.data.result.totalNumber
          // }
        })
      // console.log(this.serverParams)
    //   getFromServer(this.serverParams).then((res) => {
    //     this.totalRecords = res.totalRecords
    //     this.rows = res.rows
    //   })
    },
    onSearch (params) {
      if (params.searchTerm === '') {
        delete this.serverParams.columnFilters.SearchedCriteria
        this.loadItems()
      } else {
        this.serverParams.columnFilters.SearchedCriteria = params.searchTerm
        this.loadItems()
      }
    }
  }
}
</script>
